export function isClient() {
    return !(typeof window === "undefined" || !window || !window.localStorage)
}
